<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M14.19 4.508a1.12 1.12 0 0 0-1.065-.758H11.25v-1.5h-4.5v1.5H4.875c-.495 0-.908.315-1.065.758L2.25 9v6c0 .412.337.75.75.75h.75c.412 0 .75-.338.75-.75v-.75h9V15c0 .412.338.75.75.75H15c.412 0 .75-.338.75-.75V9l-1.56-4.492Zm-9.052.742h7.717l.78 2.25H4.358l.78-2.25Zm9.112 7.5H3.75V9.255L3.84 9h10.328l.082.255v3.495Z"/>
    <path d="M5.625 12a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm6.75 0a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
